export class BookLD {
  urlRecurso: string;
  isbn: string;
  cover: string;
  author: string;
  title: string;
  description: string;
  bookFormat: string;
}
